import {NextPage} from 'next';

import {withBasicDataServerSide} from 'core/next/controllers';
import {Events} from 'modules/events/pages/Events';
import {PageHead} from 'core/modules/PageHead';
import {metaData} from 'core/modules/PageHead/constants';
import {eventsPageController} from 'modules/events/controller';
import {EventsListProvider} from 'modules/events/provider';
import {IEventsResponseData} from 'modules/events/types';
import {IndividualTastingProvider} from 'modules/events/provider/IndividualTasting';
import {NoEventsInCity} from 'modules/events/components/NoEventsInCity';
import {ICity} from 'modules/locations/models';
import {findCityByCode} from 'modules/locations/helpers';
import {IBreadcrumb} from 'modules/seo/types';

interface IProps {
    data: IEventsResponseData | null;
    city?: ICity;
    breadcrumbs?: IBreadcrumb[];
}

const EventsPage: NextPage<{pageProps: IProps}> = ({pageProps}) => {
    const {data, city, breadcrumbs = []} = pageProps;

    const renderContent = () => {
        if (null === data) {
            return <NoEventsInCity breadcrumbs={breadcrumbs} />;
        }

        return (
            <EventsListProvider defaultData={data}>
                <IndividualTastingProvider>
                    <Events city={city} breadcrumbs={breadcrumbs} />
                </IndividualTastingProvider>
            </EventsListProvider>
        );
    };

    return (
        <>
            <PageHead
                title={metaData.events.title(city?.title)}
                description={metaData.events.description(city?.title)}
            />
            {renderContent()}
        </>
    );
};

export const getServerSideProps = withBasicDataServerSide(async (store, ctx) => {
    const result = await eventsPageController(store, ctx);

    // получаем справочник городов
    const cities = store.getState().locations.cities as ICity[];

    const userCityCode = store.getState().locations.userCityCode;

    // находим город
    const city = findCityByCode(cities, userCityCode?.toLowerCase());

    if (!result) {
        return {
            props: {
                data: null,
                city,
                breadcrumbs: [],
            },
        };
    }

    const {breadcrumbs = [], ...data} = result;

    return {
        props: {
            data,
            city,
            breadcrumbs,
        },
    };
});

export default EventsPage;
